
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/quickEditEngine/components/styles/genericComponentControl.scss.css.virtualfile';
        module.exports = {"quickEditGenericThumbnail":"_quickEditGenericThumbnail_4k2yg_7"};